import { Button } from "@material-ui/core";
import i18next from "i18next";
import { useSnackbar } from "notistack";
import { FC, memo, useEffect } from "react";
import { EVENT_NEW_SNACKBAR } from "../../constants/events";
import { areEqual } from "../../libs/utils";

export const SnackbarComponent: FC = memo((props) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleClose = (): void => closeSnackbar();

  window.addEventListener("online", function (e) {
    handleClose();
  });

  useEffect(() => {
    document.addEventListener(EVENT_NEW_SNACKBAR, (e: any) => {
      enqueueSnackbar(e.detail.message, {
        ...e.detail.options,
        action: (props) => (
          <Button {...props} onClick={handleClose} size="small" className="text-white font-weight-light">
            {i18next.t("global.close")}
          </Button>
        ),
      });
    });
  }, [enqueueSnackbar, handleClose]);

  return <></>;
}, areEqual);
